enum CostType {
  HOTEL = 'HOTEL',
  LICENSE = 'LICENSE',
  FUEL = 'FUEL',
  SHOPPING = 'SHOPPING',
  OTHER = 'OTHER'
}

export default CostType